import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FormationAreaType } from "../../../types/FormationAreaType";

const initialState: FormationAreaType = {
    id: "",
    description: "",
    status: false,
};

export const formationAreaSlice = createSlice({
    name: "formationAreaForm",
    initialState,
    reducers: {
        setFormationAreaData: (state, action: PayloadAction<FormationAreaType>) => {
            return { ...state, ...action.payload };
        },
        resetFormationAreaData: () => initialState,
    }
});

export const { setFormationAreaData, resetFormationAreaData } = formationAreaSlice.actions;
export default formationAreaSlice.reducer;
